import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { APP_COLORS } from "../../utils/constants";
import SectionTitle from "../Typography/SectionTitle";

export default function StorySectionStyle({ section, id, bgColor }) {
  return (
    <Box
      id={id}
      className="container-fluid section"
      sx={{
        color: bgColor ? APP_COLORS.BACKGROUND : APP_COLORS.FONT,
        backgroundColor: bgColor && bgColor,
      }}
    >
      <Box className="container">
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}>
            <SectionTitle title={section.title} />

            <Typography
              sx={{
                maxWidth: "35rem",
                mt: 1.5,
                opacity: 0.9,
                fontSize: { xs: "1rem", lg: "1.4rem" },
                textAlign: { xs: "center", md: "left" },
                lineHeight: 1.2,
                fontWeight: 400,
                // ml: 1,
              }}
            >
              {section.description}
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              pl: { lg: 5 },
              pt: { xs: 5, md: 0 },
              // textAlign: { xs: "justify", md: "left" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            {section.content}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
